import React, { useState } from 'react';
export function Circle(props) {
    const { className, cx, cy, fill = 'white', fillOpacity = 1, id, onClick, radius = 10, showOnHover, stroke = 'white', strokeOpacity = 0, strokeWidth = 1, toolTipKey, } = props;
    const [hovered, setHovered] = useState(false);
    const effectiveFillOpacity = !showOnHover || hovered ? fillOpacity : 0;
    const effectiveStokeOpacity = !showOnHover || hovered ? strokeOpacity : 0;
    const mouseEnterHandler = () => {
        setHovered(true);
    };
    const mouseLeaveHandler = () => {
        setHovered(false);
    };
    return (React.createElement("circle", { className: className, style: { cursor: 'pointer' }, r: radius, cx: cx, cy: cy, fill: fill, fillOpacity: effectiveFillOpacity, id: id, stroke: stroke, strokeWidth: strokeWidth, strokeOpacity: effectiveStokeOpacity, "data-cy": props['data-cy'], "data-tip": toolTipKey !== null, "data-for": toolTipKey, onClick: onClick, onMouseEnter: mouseEnterHandler, onMouseLeave: mouseLeaveHandler }));
}
//# sourceMappingURL=Circle.js.map